import React, { useState } from 'react';

import ThemeSwitcher from './ThemeSwitcher';
import NavLinkContainer from './NavLinkContainer';

import { useTheme } from '../ThemeContext';

import { FaGithub } from 'react-icons/fa'
import { BiLinkExternal } from 'react-icons/bi'
import { GiHamburgerMenu } from 'react-icons/gi'

import styled from 'styled-components';

export default function Header() {
	const theme = useTheme();
	const [menuOpen, setMenuOpen] = useState(false);

	return (
		<HeaderContainer style={{ backgroundColor: theme.header.backgroundColor }}>

			<NavLinkContainer name='Roberto Mazzalai' path='/' hideActive={true} />
			<LargeScreenNav>
				<NavLinkContainer name='Home' path='/home' />
				<NavLinkContainer name='About' path='/about' />
				<NavLinkContainer name='Hobbies' path='/hobbies' />

				<NavLinkDiv style={{ color: theme.header.color }} >
					{/* <FaGithub /> */}
					<NavLink href="https://github.com/robyconlay/homepage" target='_blank' style={{ color: theme.header.color }} >
						Source
					</NavLink>
					<BiLinkExternal style={{ color: theme.header.color }} />
				</NavLinkDiv>
			</LargeScreenNav>
			<ThemeSwitcher />
			<SmallScreenNav>
				<MenuButton onClick={() => setMenuOpen(!menuOpen)} style={{background: menuOpen ? '#333' : theme.header.backgroundColor  }}>
					<GiHamburgerMenu />
				</MenuButton>
			</SmallScreenNav>
			{menuOpen &&
				<div>
					<NavLink to="/home">Home</NavLink>
					<NavLink to="/about">About</NavLink>
					<NavLink to="/hobbies">Hobbies</NavLink>
					<div>Source</div>
				</div>
			}

		</HeaderContainer>
	)
}
const HeaderContainer = styled.header`
	display: flex;
  flex-direction: row;
  justify-content: center;
  max-height: 4rem;
  max-width: 100vw;
`;

const LargeScreenNav = styled.nav`
	display: flex;
  flex-direction: row;
  justify-content: center;
	@media screen and (max-width: 600px){
		display: none;
	}
`


const SmallScreenNav = styled.nav`
	justify-content: center;
  margin-top: auto;
  margin-bottom: auto;
	margin-left: 2rem;
	@media screen and (min-width: 600px){
		display: none;
	}
`

const NavLinkDiv = styled.div`
	padding: 20px;
  position: relative;
  justify-content: center;
  vertical-align: middle;
`

const NavLink = styled.a`
	padding: 20px;
	text-decoration: none;
	&:hover{
		color: var(--text-color-link);
  /* font-size: 1.1em; */
	}
`


const MenuButton = styled.div`
	width: 2.5rem;
	height: 2.5rem;
	border-radius: .5rem;
	border: 1px solid #ffffff60;
	color: #ffffff60;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
`
